import Image from "next/image";
import { FC } from "react";
import Link from "next/link";
import routes from "@/constants/routes";

const BetterPath: FC = () => {
  return (
    <section className="flex flex-col md:flex-row items-start md:items-center w-full py-6 lg:py-[4.625rem] text-white relative px-5 lg:pl-10 lg:pr-20 h-fit justify-between">
      <div className="hidden relative lg:flex h-60 w-96 mr-10">
        <Image
          src="/key-workers/better-path-house.svg"
          alt="building"
          objectFit="contain"
          layout="fill"
        />
      </div>
      <div className="lg:w-3/5">
        <div className="">
          <h2 className="text-4xl  font-bold text-white lg:text-5xl leading-snug">
            Keyzy offers a better path to home ownership for Key Workers
          </h2>
          <p className="mt-8 text-base lg:text-[1.625rem] text-white tracking-[-0.011em]  !leading-tight">
            For too long, essential workers have been unable to buy a home because of large deposit
            requirements and indifference from mortgage providers.
          </p>
          <p className="mt-6 text-base lg:text-[1.625rem] text-white tracking-[-0.011em]  !leading-tight">
            Keyzy buys your chosen home for you, and lets you rent it while saving a portion of your
            rent each month. You can buy it back from Keyzy when you are ready, and keep any
            increase in value.
          </p>
          <div className="flex flex-col md:flex-row md:my-12 lg:my-0">
            <div className="">
              <Link href={`${routes.home}#howitworks`}>
                <a className="inline-block w-full px-4 py-3 mx-auto mt-10 md:mt-0 lg:mt-12 mb-4 text-base font-bold text-center text-white transition duration-300 ease-in-out transform rounded shadow md:mb-0 md:w-auto bg-landing-orange hover:scale-105">
                  See how Keyzy works
                </a>
              </Link>
            </div>
            <div className="relative lg:hidden h-40 w-72 mx-auto my-24 md:my-0">
              <Image
                src="/key-workers/better-path-house.svg"
                alt="building"
                objectFit="contain"
                layout="fill"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetterPath;
